export const MESSAGE_MODE_FIXED = 'fixed';
export const MESSAGE_MODE_AI = 'ai';

export type MessageMode = typeof MESSAGE_MODE_FIXED | typeof MESSAGE_MODE_AI;
